define('controllers/admin/memberagreement',['require','nicEditlatest'],function (require) {
    require('nicEditlatest');
    return function () {
        var agreements = window.ServerData.feData.agreements;
        var ddlAgreeements = $("#ddlAgreeements"),
                msg = $(".alert"),
                taContentId = "taContent",
                taContent = new nicEditor({ fullPanel: true, maxHeight: 500 }).panelInstance(taContentId, { hasPanel: true }),
                txtDesc = $("input[name='Description']"),
                anchorView = $("#anchorView"),
                loading = $("#loadingAgreement");

        //bind agreements
        BindAgreements();
        function BindAgreements() {
            var options = [];
            for (var i = 0; i < agreements.length; i++) {
                var agreement = agreements[i],
                    template = "<option value='{0}'>{1}</option>";

                options.push(template.format(agreement.id, agreement.Description));
            }
            ddlAgreeements.html(options.join(""));
        }

        ddlAgreeements.on("change", function () {
            var id = ddlAgreeements.val();

            setAnchorView(id);

            if (id > 0) {
                loading.show();

                $.post("MAAJAX.aspx", { method: "getSingle", id: id }, function (response) {
                    Utilities.handleAJAXResponse(response, function (agreement) {
                        txtDesc.val(agreement.Description);
                        taContent.instanceById(taContentId).setContent(agreement.Content);
                    },
                    function (error) {
                        Utilities.setError(error, msg);
                    });
                }).complete(function () {
                    loading.hide();
                });
            } else {
                $("input[name='id']").val("0");
                $("input[name='Description']").val("");
                taContent.instanceById("taContent").setContent("");
            }
        });

        $("#btnSave").on("click", function () {
            var $this = $(this),
                agreement = {
                    method: "save",
                    id: ddlAgreeements.val(),
                    Description: txtDesc.val(),
                    Content: Utilities.htmlEncode(taContent.instanceById(taContentId).getContent())
                };

            $this.prop('disabled', true);
            $.post("MAAJAX.aspx", agreement, function (response) {
                Utilities.handleAJAXResponse(response, function (newId) {
                    setAnchorView(newId);
                    if (agreement.id == 0) {
                        //add to list and set selected...
                        agreements.push({ id: newId, Description: agreement.Description });
                        BindAgreements();
                        $("option[value='{0}']".format(newId), ddlAgreeements).prop('selected', true);
                        anchorView
                    } else {
                        $("option[value='{0}']".format(newId), ddlAgreeements).text(agreement.Description);
                    }
                    Utilities.setInfo("Saved Successfully!", msg);
                },
                function (error) {
                    Utilities.setError(error, msg);
                });
            }).complete(function () {
                $this.prop('disabled', false);
            });
        });

        function setAnchorView(id) {
            id > 0 ? anchorView.attr("href", "/membershipagreement/?aid=" + id).show() : anchorView.hide();
        }

    };
});
